import Components from "slotworks/components/components";
import PromptContent from "slotworks/components/prompt/prompt-content";
import RevolverModel from "slotworks/integration/revolver/model/revolver-model";
import SettingsModel from "slotworks/model/settings/settings-model";
import Contract from "slotworks/utils/contract";
import BackCommand from "slotworks/commands/betbar/back-command";

export function SessionLimitCommand(message: string, homeURL: string) {
    return new Contract<boolean>((resolve) => {
        // TODO: Convert to generic confirm box?
        const goHome = () => {
            if (homeURL === "close") {
                window.close();
            } else if(homeURL === "back") {
                BackCommand();
            } else {
                window.open(homeURL, "_self");
            }

            resolve(true);
        };

        const prompt = new PromptContent(["sessionlimit"]);

        const contents = new Map<string, string>();
        contents.set("body", message);
        prompt.addText(contents);

        prompt.addContinueButton("yes");
        prompt.addButton("no", () => {
            Components.prompt.hide();
            resolve(false);
        });

        // TODO: Decouple revolver specific code
        const historyLink = document.getElementById("accountHistoryLink") as HTMLAnchorElement;
        if (historyLink) {
            historyLink.href = SettingsModel.historyURL + RevolverModel.session + "?lang=" + SettingsModel.language;
            historyLink.target = "_blank";
        }

        Components.prompt.showPrompt(prompt).then(goHome);
    });
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/error/session-limit-command.ts